import React, { Fragment, useState } from 'react';
import {
  CardTitle,
  Card,
  CardContent,
  Input,
  withGrid,
  ListItemActions,
  Option,
  Select,
  Button,
  Textarea
} from '../../../Components';
import { PreProjetoModel, ProfessorModel, SituacaoDoPreProjeto } from '../../../Store';
import { media } from '../../../Themes';
import styled from 'styled-components';
import { Tag } from '../../../Components/Tag/Tag';

interface IDetalhePreProjetoProps {
  preprojeto: PreProjetoModel,
  professores: ProfessorModel[]
  orientador: ProfessorModel,
  vagas: number,
  onSelectChange: (event: React.ChangeEvent<HTMLSelectElement>) => any,
  onAprovar: (preProjetoId: number, professorId: number) => any
}

const Grid = withGrid(CardContent);
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const TextAreaGrid = styled(Textarea) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const StyledInfo = styled.span`
  margin-left: 16px; 
`;

const StyledButton = styled(Button) <any>`
  margin-left: 16px
`;

const Div = styled.div<any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;
  white-space: pre-line;

  color: #3d3d3d; 
  font-weight: normal;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const P = styled.p<any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  color: #919191; 
  font-weight: normal;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const StyledSelect = styled(Select) <any>`
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 25px;
  grid-column: ${p => p.gridColumn};
`;

const StyledTags = styled.div`
  flex-direction: row;
`;

export default function DetalhesPreProjeto(props: IDetalhePreProjetoProps) {
  const { preprojeto, professores, orientador, vagas, onSelectChange, onAprovar } = props;
  const [confirmar, setConfirmar] = useState(false)

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onSelectChange(event)
    setConfirmar(false)
  }

  const Options =
    <>
      <Option value={0}> Selecione um orientador... </Option>
      {professores.map(p => (
        <Option value={p.id} key={p.id}>
          {p.nome}
        </Option>
      ))}
    </>

  return (
    <>
      <Card>
        <CardTitle>Informações do Pré-Projeto</CardTitle>
        <CardContentGrid>
          <InputGrid
            gridColumn='1/8'
            name='nome'
            label='Nome do Aluno'
            disabled={true}
            value={preprojeto.aluno.nome}
          />
          <InputGrid
            gridColumn='8/14'
            name='email'
            label='Email do Aluno'
            disabled={true}
            value={preprojeto.aluno.email}
          />
          <TextAreaGrid
            gridColumn='1/14'
            name='titulo'
            label='Título'
            disabled={true}
            value={preprojeto.titulo}
          />
          <TextAreaGrid
            gridColumn='1/14'
            name='tema'
            label='Tema'
            disabled={true}
            value={preprojeto.tema}
          />
          <P>Desenvolvimento</P>
          <Div gridColumn='1/14'>{preprojeto.desenvolvimento}</Div>
          <P>Justificativa</P>
          <Div gridColumn='1/14'>{preprojeto.justificativa}</Div>
          <P>Bibliografia</P>
          <Div gridColumn='1/14'>{preprojeto.bibliografia}</Div>

          <P>Orientadores</P>
          {preprojeto.orientadores && preprojeto.orientadores
          .sort((a, b) => a.ordemParaConvite - b.ordemParaConvite)
          .map((o, i) =>
            <Fragment key={i}>
              <TextAreaGrid
                gridColumn='1/8'
                name='Orientadores:'
                label={`Opção ${i + 1}`}
                disabled={true}
                value={o.professor.nome}
              />
              <ListItemActions>
                <StyledTags>
                  {(() => {
                    switch (o.conviteAceito) {
                      case true:
                        return <Tag color='approvedColor'>Orientação aceita</Tag>;
                      case false:
                        return <Tag color='errorColor'>Orientação não aceita</Tag>;
                      default:
                        return <Tag color='primaryColor'>Seleção pendente</Tag>;
                    }
                  })()}
                </StyledTags>
              </ListItemActions>
            </Fragment>
          )}
        </CardContentGrid>
      </Card>
      {preprojeto && preprojeto.situacao == SituacaoDoPreProjeto.recusado &&
        <Card>
          <CardTitle>Atribuir Orientador:</CardTitle>
          <CardContent>
            <StyledSelect
              name='orientador'
              value={orientador ? orientador.id : 0}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(e)}
              gridColumn='1/8'
            >
              {Options}
            </StyledSelect>
            <StyledInfo color='primaryColor'>Nº de Vagas: {vagas || 0} </StyledInfo>
            {!confirmar &&
              <StyledButton disabled={!vagas || vagas == 0 && true}
                onClick={() => setConfirmar(true)}>
                Atribuir
              </StyledButton>
            }
            {confirmar &&
              <StyledButton disabled={!vagas || vagas == 0 && true}
                onClick={() => onAprovar(preprojeto.id, orientador && orientador.id)}>
                Confirmar
            </StyledButton>
            }
          </CardContent>
        </Card>
      }
    </>
  );
}
